// extracted by mini-css-extract-plugin
module.exports = {"table":"gameTable-module--table--2twFU","column":"gameTable-module--column--2aCJ0","button":"gameTable-module--button--KL3lZ"};